import { CardContent, CardContentProps } from '@mui/material'
import { FC } from 'react'

const CardContentWrapper: FC<CardContentProps> = ({ ...props }) => <CardContent {...props} />

export default CardContentWrapper
